import { useMutation, useQuery } from "@apollo/client";
import { useCallback } from "react";
import { graphql } from "../../gql";

export const GetAllOnboardingLivePdfsQuery = graphql(`
  query getAllOnboardingLivePdfs {
    getAllOnboardingLivePdfs {
      userGroupId
      pdfUrl
    }
  }
`);

const UpsertOnboardingLivePdfMutation = graphql(`
  mutation upsertOnboardingLivePdf($userGroupId: String!, $pdfUrl: String!) {
    upsertOnboardingLivePdf(userGroupId: $userGroupId, pdfUrl: $pdfUrl) {
      userGroupId
      pdfUrl
    }
  }
`);

const DeleteOnboardingLivePdfMutation = graphql(`
  mutation deleteOnboardingLivePdf($userGroupId: String!) {
    deleteOnboardingLivePdf(userGroupId: $userGroupId)
  }
`);

export function useOnboardingLivePdfs() {
  const { data, loading } = useQuery(GetAllOnboardingLivePdfsQuery, {
    fetchPolicy: "cache-and-network",
  });
  const [upsertMutation, { loading: saving }] = useMutation(
    UpsertOnboardingLivePdfMutation,
    { refetchQueries: [GetAllOnboardingLivePdfsQuery] },
  );
  const [deleteMutation, { loading: deleting }] = useMutation(
    DeleteOnboardingLivePdfMutation,
    { refetchQueries: [GetAllOnboardingLivePdfsQuery] },
  );
  const upsertPdf = useCallback(
    async (userGroupId: string, pdfUrl: string) => {
      await upsertMutation({ variables: { userGroupId, pdfUrl } });
    },
    [upsertMutation],
  );
  const deletePdf = useCallback(
    async (userGroupId: string) => {
      await deleteMutation({ variables: { userGroupId } });
    },
    [deleteMutation],
  );
  return {
    pdfs: data?.getAllOnboardingLivePdfs ?? [],
    loading,
    saving: saving || deleting,
    upsertPdf,
    deletePdf,
  };
}
